/**
 * useAnalyticsBeacon — fires a POST to /api/analytics/beacon on every
 * `location.pathname` change. Non-blocking; failures are silent so a
 * dead beacon endpoint can never break navigation.
 *
 * Uses `navigator.sendBeacon` when available (survives page unload).
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useAnalyticsBeacon(portalSlug) {
  const loc = useLocation();
  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL || ""}/api/analytics/beacon`;
    const body = JSON.stringify({
      path: loc.pathname,
      portal_slug: portalSlug || "socialpulse",
      ref: document.referrer || null,
      event_id: (() => {
        // /event/:eventId → capture for per-story rollups.
        const m = loc.pathname.match(/^\/event\/([^/]+)/);
        return m ? m[1] : null;
      })(),
    });
    try {
      const t = localStorage.getItem("sp_token") || localStorage.getItem("token") || "";
      if (navigator.sendBeacon && !t) {
        // sendBeacon is fire-and-forget (no auth header support), so we
        // use it for anonymous nav only. Signed-in nav uses fetch below.
        const blob = new Blob([body], { type: "application/json" });
        navigator.sendBeacon(url, blob);
      } else {
        fetch(url, {
          method: "POST",
          body,
          headers: {
            "Content-Type": "application/json",
            ...(t ? { Authorization: `Bearer ${t}` } : {}),
          },
          keepalive: true,
        }).catch(() => {});
      }
    } catch {
      /* silent */
    }
  }, [loc.pathname, portalSlug]);
}

export default useAnalyticsBeacon;
